import React, { Component } from "react";
import HeaderPaper from "./common/headerPaper";
import Grid from "@material-ui/core/Grid";
import { Button, Typography } from "@material-ui/core";
import { Helmet } from "react-helmet";

class Accme extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>ACCME - Acabest</title>
        </Helmet>

        <HeaderPaper headerTitle="MDC EXAM PREP PROGRAM" />

        <Grid
          container
          // item
          xs={9}
          lg={6}
          style={{ margin: "30px auto", textAlign: "justify" }}
        >
          <Grid>
            <Typography>
              We are excited to support you with comprehensive prep programs for
              both your MCQ and OSCE exams. Our MCQ track is fully online for
              your convenience, covering the entire spectrum of basic sciences
              and clinical disciplines.
            </Typography>
            <br />
            <Typography>
              For the OSCE, we offer a hands-on experience primarily hosted at
              our mini skills lab, supplemented by targeted online sessions.
              We’ll walk you through every aspect of the Stage 2 exam—from
              history-taking and physical examinations to procedures, data
              interpretation, and the Community Health Viva.
            </Typography>
            <br />
            <Typography style={{ fontSize: "13px", color: "grey" }}>
              {/* <a
              href="https://youtu.be/FWVbh3DFLkg?si=PFVx_Eip6EeKRrBy"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "underline", color: "blue" }}
            >
              Click here
            </a>{" "}
            to watch a sample of our ACCME Paediatrics MCQs online session for
            June 2023 on Youtube.
            <br />
            <br /> */}
              {/* <a
                href="https://wa.me/message/RA3ZX3V2YX5ZB1"
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ margin: "10px auto" }}
                >
                  Register! / Make Enquiries
                </Button>
              </a>
              <br /> */}
              {/* <br /> */}
            </Typography>
          </Grid>
          {/* <h2 style={{ fontSize: "23px" }}>What will we be covering?</h2>
          <Typography>
            We'll be covering the following disciplines;{" "}
            <strong>
              Medicine, Surgery, Paediatrics, Obstetrics and Gynaecology, and
              Public Health.
            </strong>
          </Typography>{" "}
          <br />
          <Typography>
            The structure of the course includes in person sessions for the
            clinical examination and procedures, online sessions for unmanned
            OSCE pictures, data interpretation, and history taking. Plus access
            to over 120 clinical guides for examination, procedures and Viva on
            our website.
          </Typography>
          <br />
          <Typography>
            For the in-persion sessions, we'll go through Medicine and
            Paediatric <strong>examination for all systems.</strong> In addition
            to these, we'll cover{" "}
            <strong>neonatal resuscitation and newborn examination</strong> for
            Paediatrics.
          </Typography>{" "}
          <br />
          <Typography>
            {" "}
            For Obs & Gynae, we'll cover{" "}
            <strong>
              examination of gravid uterus, gynae abdominal exam, pelvic exam,
              and vaginal and cervical swabbing.
            </strong>
            . For Surgery, we'll cover the 5 short cases;{" "}
            <strong>
              thyroid, breast, ulcer, superficial swellings and hernia exam.
              We'll also look at DRE.
            </strong>
          </Typography>{" "}
          <br />
          <Typography>
            We'll also look at the common procedures encountered in the exams
            such as IV cannulation (for IV fluids or sample), urethral
            catheterization, urine dipstick, RBS, NG tube insertion, neonatal
            resuscitation, vaginal and cervical swabs.
          </Typography>{" "}
          <br />
          <Typography>
            You'll have 3 sessions per week at the skills lab, each lasting 3
            hours. 2 of these sessions will be with a tutor while the third will
            be on your own as a group to practice the skills you've acquired in
            the week. You will have all the resources available to practice as
            many times as you need to master the skills.
            <br />
            <br />
          </Typography>
          <br />
          <Grid>
            <h2 style={{ fontSize: "23px" }}>Will a Mock exam be organized?</h2>
            <Typography>
              A mock exam will be organized towards the end of the program. A
              mock for stage 2 unmanned is confirmed but we are still
              considering the possibility of a mock for the manned OSCE as it
              requires a lot more resources.
            </Typography>
            <Typography>
              A mock is expensive to organize, but it will come at no additional
              cost for those already on the program. Others will be allowed to
              join at a cost which will be communicated later.
            </Typography>
            <br />
          </Grid>
          <br />
          <Grid>
            <h2 style={{ fontSize: "23px" }}>
              Is there any accomodation arrangement?
            </h2>
            <Typography>
              Since many candidates that joined our previous program requested
              for accomodation, we are currently working on securing
              accomodation for those who may need it. We can't really tell the
              cost yet but the average cost for 2 in a room hostels around are
              from 700 to 900 per month depending on the resources available.
              Let us know if you'll need acccomodation.
            </Typography>
          </Grid> */}
          {/* <br /> */}
          <Grid>
            {/* <h2 style={{ fontSize: "23px" }}>How much does it cost?</h2>
            <Typography>
              <strong>GHC 1,100 per month</strong>
            </Typography>
            <Typography>
              Note that the course is a 3 month structured course. That means if
              you join towards the end of the first month or at the beginning of
              the second month, sessions you've missed from the previous month
              will have to be reorganized for you and that will come at a cost.
            </Typography>
            <Typography>
              <strong>Note:</strong> The slots are limited!
            </Typography> */}
            {/* <br /> */}
            <Typography>
              Click on the button below to WhatsApp us to initiate your
              registration or make enquiries.
            </Typography>

            {/* <br /> */}
            <br />
            <a
              href="https://wa.me/message/RA3ZX3V2YX5ZB1"
              target="_blank"
              rel="noreferrer"
            >
              <Button
                variant="contained"
                color="secondary"
                style={{ margin: "10px auto" }}
              >
                Register! / Make Enquiries
              </Button>
            </a>
            <br />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default Accme;
